module.exports = __webpack_public_path__ + "static/media/ErrorBoundary.8fc3e468.png";